/**
 * Конфигурация фронтенда
 * Загружает переменные окружения и настройки для работы с Supabase
 */

interface AppConfig {
  // Supabase Configuration
  supabaseUrl: string;
  supabaseAnonKey: string;

  // API Configuration
  apiBaseUrl: string;
  apiUrl: string; // Alias for apiBaseUrl

  // Feature Flags
  authEnabled: boolean;

  // Telegram Configuration
  telegramBotUsername: string;

  // Stripe Configuration
  stripePublishableKey: string;

  // Environment
  environment: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

const config: AppConfig = {
  // Supabase
  supabaseUrl: process.env.REACT_APP_SUPABASE_URL || '',
  supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || '',

  // API
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  apiUrl: process.env.REACT_APP_API_BASE_URL || '', // Alias

  // Feature Flags
  authEnabled: process.env.REACT_APP_AUTH_ENABLED === 'true',

  // Telegram
  telegramBotUsername: process.env.REACT_APP_TELEGRAM_BOT_USERNAME || '',

  // Stripe
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',

  // Environment
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

// Валидация конфигурации
export function validateConfig(): string[] {
  const errors: string[] = [];
  
  if (config.authEnabled) {
    if (!config.supabaseUrl) {
      errors.push('REACT_APP_SUPABASE_URL is required when auth is enabled');
    }
    if (!config.supabaseAnonKey) {
      errors.push('REACT_APP_SUPABASE_ANON_KEY is required when auth is enabled');
    }
  }
  
  if (!config.apiBaseUrl) {
    errors.push('REACT_APP_API_BASE_URL is required');
  }
  
  return errors;
}

// Проверяем конфигурацию при загрузке
const configErrors = validateConfig();
if (configErrors.length > 0) {
  console.warn('Configuration warnings:', configErrors);
}

export default config;
